<template>
    <div class="ticket-print-page">
        <div class="ticket-print-title">{{ $t('Sell.TicketPrint.statement') }}</div>
        <div class="ticket-print-content">
            <div>{{ $t('Common.time') }} ：</div>
            <div v-if="activeName === 'deposit'" class="mt-2">{{ $t('Sell.TicketPrint.type') }} ：{{ $t('Charge.member_card') }}</div>
            <div v-else class="mt-2">{{ $t('Contract.number2') }} ：{{ form.contractNum }}</div>
            <div class="ticket-print-line"></div>
            <div class="flex items-center ticket-table-rows mb-2">
                <div>{{ $t('Sell.TicketPrint.entry_name') }}</div>
                <div>{{ $t('Reception.Fourth.count') }}</div>
                <div>{{ $t('Sell.TicketPrint.unitprice') }}</div>
                <div>{{ $t('Sell.TicketPrint.subtotal') }}</div>
            </div>
            <div class="flex items-center ticket-table-rows">
                <div>{{ form.item }}</div>
                <div>{{ form.count }}</div>
                <div>{{ form.price }}</div>
                <div>{{ form.subTotal }}</div>
            </div>
            <div class="mt-10">{{ $t('Common.remark') }}：{{ form.remark ? form.remark : '无' }}</div>
            <div class="ticket-print-line"></div>
            <template v-if="!['subscription', 'deposit'].includes(activeName)">
                <div>{{ $t('Sell.standard_amount') }}：{{ form.baseAmt }}</div>
                <div class="mt-2">{{ $t('Charge.discounted_price') }}：{{ form.discountAmt }}</div>
                <div class="mt-2">{{ $t('Charge.amount_receivable') }}：{{ form.payableAmt }}</div>
                <div class="mt-2">{{ $t('Sell.Charge.paid_amount') }}：{{ form.paidAmt }}</div>
            </template>
            <div v-if="form.refundAmt" class="mt-2">{{ $t('Sell.TicketPrint.refund_amount') }}：{{ form.refundAmt }}</div>
            <div class="ticket-print-line"></div>
            <div>{{ $t('Sell.TicketPrint.Actual_receipt_details') }}：</div>
            <div v-for="(item, index) in form.details" :key="index" class="mt-2">{{ item }}</div>
            <template v-if="activeName === 'deposit' && form.refundDetails">
                <div class="ticket-print-line"></div>
                <div>{{ $t('Sell.TicketPrint.Refund_details') }}：</div>
                <div :key="index" class="mt-2">{{ form.refundDetails }}</div>
            </template>
            <div class="ticket-print-line"></div>
            <div>{{ $t('Sell.TicketPrint.merchant') }}：{{ form.storeName }}</div>
            <div class="ticket-print-line"></div>
            <div>{{ $t('Common.name') }}：{{ form.clientName }} </div>
            <div class="mt-2">{{ $t('Common.phone') }}：{{ form.clientPhone }}</div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: [],
    data() {
        return {
            activeName: this.$route.query.activeName,
            contractNum: this.$route.query.contractNum,
            form: {},
            time: null,
        };
    },
    methods: {
        filterTime() {
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            const hour = date.getHours();
            let minutes = date.getMinutes();
            let second = date.getSeconds();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            if (minutes < 10) minutes = `0${minutes}`;
            this.time = `${year}-${month}-${day} ${hour}:${minutes}:${second}`;
        },
        fetchData() {
            API.get(`contract/common/${this.contractNum}/receipt`)
            .then(res => {
                this.form = res;
            });
        },
    },
    created() {
        this.filterTime();
        this.fetchData();
    },
};
</script>

<style lang="scss">
.ticket-print-page {
    font-size: 13px;
    width: 220px;
}
.ticket-print-title {
    font-size: 2.2rem;
}
.ticket-print-content {
    margin-top: 30px;
}
.ticket-print-line {
    width: 100%;
    margin: 15px 0;
    border-bottom: 2px dotted #000;
}
.ticket-table-rows {
    white-space: normal;
    word-break: break-all;
    div {
        width: 20%;
        &:first-child {
            width: 40%;
        }
    }
}
</style>
